import { z } from 'zod';
/**
 * Hilfen für Eingabeschemata, die mehrere Module brauchen. Fachliches gehört nicht hierher, sondern in den Ordner des Moduls.
 */
/** Leere Eingaben aus Formularen gelten als nicht angegeben */
export const optionalText = (max) => z
    .string()
    .trim()
    .max(max)
    .optional()
    .transform((v) => (v === '' ? undefined : v));
/** Beim Ändern löscht null oder eine leere Eingabe den Wert, undefined lässt ihn unverändert */
export const nullableText = (max) => z
    .string()
    .trim()
    .max(max)
    .nullable()
    .optional()
    .transform((v) => (v === '' ? null : v));
/** Liste von Benutzern (IDs), zum Beispiel Beteiligte oder Teilnehmer. Doppelte Einträge werden entfernt, höchstens 50. Sie ersetzt beim Ändern die bisherige Liste. */
export const userIdList = z
    .array(z.uuid('Ungültiger Benutzer'))
    .max(50, 'Höchstens 50 Personen')
    .transform((ids) => [...new Set(ids)]);
/**
 * Mehrere IDs in einem Abfrageparameter, durch Kommas getrennt („a,b,c“), für Filter mit Mehrfachauswahl. Leer oder fehlend ergibt eine leere Liste,
 * doppelte Einträge entfallen, höchstens 50.
 */
export const idListParam = z
    .string()
    .trim()
    .max(2000)
    .optional()
    .transform((v) => (v ? [...new Set(v.split(',').map((x) => x.trim()).filter(Boolean))] : []))
    .pipe(z.array(z.uuid('Ungültige ID')).max(50, 'Höchstens 50 Einträge'));
/** Datum als JJJJ-MM-TT. Leere Eingaben gelten als nicht angegeben. */
export const optionalDate = z
    .string()
    .trim()
    .optional()
    .transform((v) => (v === '' ? undefined : v))
    .pipe(z.iso.date('Ungültiges Datum').optional());
/** Datum beim Ändern: null oder eine leere Eingabe löscht es, undefined lässt es unverändert */
export const nullableDate = z
    .string()
    .trim()
    .nullable()
    .optional()
    .transform((v) => (v === '' ? null : v))
    .pipe(z.iso.date('Ungültiges Datum').nullable().optional());
//# sourceMappingURL=common.js.map